export type TTimeBufferAlert = 'OK' | 'EARLY' | 'WARNING' | 'DANGER' | 'LATE';

const TimeBufferAlerts: Record<TTimeBufferAlert, IStatusOption<TTimeBufferAlert>> = {
  OK: { index: 4, value: 'OK', key: 'OK', label: 'timeBufferAlertOptions.OK', color: 'green' },
  EARLY: {
    index: 3,
    value: 'EARLY',
    key: 'EARLY',
    label: 'timeBufferAlertOptions.EARLY',
    color: 'blue'
  },
  WARNING: {
    index: 2,
    value: 'WARNING',
    key: 'WARNING',
    label: 'timeBufferAlertOptions.WARNING',
    color: 'orange'
  },
  DANGER: {
    index: 1,
    value: 'DANGER',
    key: 'DANGER',
    label: 'timeBufferAlertOptions.DANGER',
    color: 'red'
  },
  LATE: {
    index: 0,
    value: 'LATE',
    key: 'LATE',
    label: 'timeBufferAlertOptions.LATE',
    color: 'red-6'
  }
};

export const TimeBufferAlertOptions = (Object.keys(TimeBufferAlerts) as TTimeBufferAlert[]).map(
  (key: TTimeBufferAlert) => {
    return TimeBufferAlerts[key];
  }
);

export default TimeBufferAlerts;
